import { render, staticRenderFns } from "./t-blackout.vue?vue&type=template&id=4be3291a&"
import script from "./t-blackout.vue?vue&type=script&lang=js&"
export * from "./t-blackout.vue?vue&type=script&lang=js&"
import style0 from "./t-blackout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports